export default "__VITE_ASSET__CWae4Hxa__"